import React, { useState, useContext, } from 'react';
import { Form, Space, Select, Input, Button, } from 'antd';
import { PartitionOutlined } from '@ant-design/icons';
import { Status } from '../../Status/Status.component';
import { DeviceButtonGroup } from '../DeviceButtonGroup.component';
import { DeleteDeviceModal } from '../../../Modals/DeleteDeviceModal.component.';
import { getDeviceTitle } from '../DevicesList/DevicesList.component';
import { DeleteDeviceButton } from '../DeleteDeviceButton.component';
import { GroupedDevicesTable, SerialNumCell, } from '../GroupedDevicesTable.component';
import { VLANTableModal } from '../../../Modals/VLANTableModal.component';
import { DeviceRestrictedInput } from '../DeviceRestrictedInput.component';
import { PermissionsContext } from '../../../../../router/DashboardRoutes';
import { Restricted } from '../../../../UI/Restricted.component';

export const CloudSwitches = ({ data, isPanelPending, saveChanges, renderEditableCellValue, profileCombination, ...props}) => {

    const userPermissions = useContext(PermissionsContext);
    const isPCI = userPermissions.server.pci;

    const [deleteModal, setDeleteModal] = useState({display: false, record: ''});
    const [currentDevice, setCurrentDevice] = useState();
    const [displayVLANTable, setDisplayVLANTable] = useState(false);

    const licenseDisabled = ['CSDFS', 'CSBASE', 'CSEVC'];

    const licenseOptions = [
        {
            value: 1, 
            label: 'FREE'
        }, 
        {
            value: 0, 
            label: 'NAC'
        }, 
        {
            value: 2, 
            label: 'VLAN'
        }, 
    ]

    const deleteDevice = (record) => {
        setDeleteModal({display: true, record: record});
    }

    const onClickVLANTable = (record) => {
        setDisplayVLANTable({display: true, device: record })
    }

    const columns = [
        {
            title: 'Serial Number',
            dataIndex: 'serialNum',
            key: 'serialNum',
            width: 150,
            render: (value, record) => {
                return (
                    <SerialNumCell panelPending={isPanelPending(record)} value={value}/>
                )
            }
        },
        {
            title: 'Description',
            dataIndex: 'comment',
            key: 'comment',
            render: (value, record) => renderEditableCellValue(value, record, 'comment')
        },
        {
            title: 'Firmware Version',
            dataIndex: 'version',
            key: 'version',
        },
        {
            title: 'OS Version',
            dataIndex: 'routerversion',
            key: 'routerversion',
        },
        {
            title: 'Mode',
            dataIndex: 'licensed',
            key: 'licensed',
            width: 100,
            render: (value, record) => {
                const getLabel = (license) => {
                    let mode = licenseOptions.find(option => option.value === license);
                    return mode?.label;
                }

                return (
                    <>
                        {getLabel(renderEditableCellValue(value, record, 'licensed'))}
                    </>
                )
            }
        },
        {
            title: 'VPN Status', 
            dataIndex: 'status',
            key: 'status',
            width: 120,
            render: (status) => {
                return <Status status={status}/>
            },
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: 370,
            render: (_, record) => {
                return (
                    <Space size='small' onClick={(e) => e.stopPropagation()}>
                        {(record.deviceType === 'CSBASE' && isPCI) && 
                            <Restricted to='server.pci'>
                                <Button 
                                    icon={<PartitionOutlined 
                                    style={{transform: 'rotate(90deg)'}} />} 
                                    onClick={() => onClickVLANTable(record)}
                                    >
                                    VLAN Table
                                </Button> 
                            </Restricted>
                        }
                        <DeviceButtonGroup serialNum={record.serialNum} status={record.status} hostTable={record.deviceType !== 'CSBASE'} ant={record.deviceType !== 'CSBASE'} winbox/>
                        {/* <DeleteDeviceButton pending={isPanelPending(record)} onClick={() => deleteDevice(record)} /> */}
                    </Space>
                );
            },
        },
        {
            dataIndex: 'delete', 
            key: 'delete', 
            render: (_, record) => {
                return (
                    <DeleteDeviceButton pending={isPanelPending(record)} onClick={() => deleteDevice(record)} />
                );
            }
        }
    ];

    const formItems = (
        <>
            <DeviceRestrictedInput label='Description:' name='comment'  >
                <Input/>
            </DeviceRestrictedInput>
            <DeviceRestrictedInput label='Firmware Version:' name='version'>
                <Input disabled/>
            </DeviceRestrictedInput>
            <DeviceRestrictedInput label='OS Version:' name='routerversion'>
                <Input disabled/>
            </DeviceRestrictedInput>
            <Form.Item label='Mode:' name='licensed' tooltip={licenseDisabled.includes(currentDevice?.deviceType)  && "This field can't be edited"}>
                <Select options={licenseOptions} disabled={licenseDisabled.includes(currentDevice?.deviceType)}/>
            </Form.Item>
        </>
    );

    return (
        <>
            <GroupedDevicesTable
                columns={columns}
                // dataSource={data}
                dataSource={[...data].sort((a,b) => {
                    // Display CSBASE devices last
                    if(a.deviceType === 'CSBASE') return 1;
                    if(b.deviceType === 'CSBASE') return -1;
                    return 0;
                })}
                formItems={formItems}
                isPanelPending={isPanelPending}
                saveChanges={saveChanges}
                currentDevice={currentDevice}
                setCurrentDevice={setCurrentDevice}
            />

            { deleteModal.display && 
                <DeleteDeviceModal 
                    title={getDeviceTitle(deleteModal.record.deviceType)} 
                    item={deleteModal.record} 
                    visible={deleteModal.display} 
                    setVisible={setDeleteModal}>
                </DeleteDeviceModal>
            }


            { displayVLANTable.display &&
                <VLANTableModal 
                    device={displayVLANTable.device}
                    visible={displayVLANTable.display}
                    setVisible={setDisplayVLANTable}
                    profileCombination={profileCombination}
                />
            }
        </>
    );
}
